import React from 'react';

import { Loader } from '..';
import styles from './TranscodingOverlays.scss';

export const TranscodingOverlay: React.FC = () => (
  <div className={styles.loader} data-hook="transcoding-overlay">
    <Loader size="small" />
  </div>
);
